import { Box, Icon, IconButton, useBreakpointValue } from "@chakra-ui/react";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useRef, useState } from "react";

const BlogCardCarousel = ({
    children,
    gap = 24,
    isCitiesSection,
    isBlogSection,
    cardsToShow = { base: 1, sm: 1, md: 2, xl: 3, "2xl": 3 },
}) => {
    const containerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalItems = children?.length;
    const currentCards = useBreakpointValue(cardsToShow) || 1;

    let cardWidth = useBreakpointValue({ base: 300, sm: 364 }) || 364;

    const totalWidth = totalItems * (cardWidth + gap);
    const visibleWidth = currentCards * (cardWidth + gap) - gap;

    useEffect(() => {
        setCurrentIndex((prev) => Math.min(prev, Math.max(0, totalItems - currentCards)));
    }, [currentCards, totalItems]);

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => Math.max(0, prev - 1));
        }
    };

    const handleNext = () => {
        if (currentIndex < totalItems - currentCards) {
            setCurrentIndex((prev) => Math.min(totalItems - currentCards, prev + 1));
        }
    };

    return (
        <Box position="relative" w={`${visibleWidth}px`} margin="0 auto">
            <Box
                ref={containerRef}
                overflow="hidden"
                // overflowY={"visible"}
                width="100%"
            >
                <Box
                    as="div"
                    transform={`translateX(-${currentIndex * (cardWidth + gap)}px)`}
                    transition={`transform ${0.3}s ease-out`}
                    style={{
                        display: "flex",
                        gap: `${gap}px`,
                        width: `${totalWidth}px`,
                    }}
                >
                    {children &&
                        children.length > 0 &&
                        children.map((child, index) => (
                            <Box
                                key={index}
                                width={`${cardWidth}px`}
                                //   height={`${cardHeight}px`}
                                flexShrink={0}
                            >
                                {child}
                            </Box>
                        ))}
                </Box>
            </Box>
            <IconButton
                onClick={handlePrev}
                aria-label="Anterior"
                size="lg"
                borderRadius="full"
                position="absolute"
                left={`-${gap + 2}px`}
                top="35%"
                transform="translateY(-50%)"
                zIndex="10"
                bg="white"
                boxShadow="md"
                _hover={{ bg: "gray.100" }}
                disabled={currentIndex === 0}
                opacity={currentIndex === 0 ? 0.4 : 1}
                cursor={currentIndex === 0 ? "not-allowed" : "pointer"}
            >
                <Icon boxSize={6} color="black">
                    <CaretLeftIcon />
                </Icon>
            </IconButton>
            <IconButton
                onClick={handleNext}
                aria-label="Siguiente"
                size="lg"
                borderRadius="full"
                position="absolute"
                right={`-${gap + 2}px`}
                top="35%"
                transform="translateY(-50%)"
                zIndex="10"
                bg="white"
                boxShadow="md"
                _hover={{ bg: "gray.100" }}
                disabled={currentIndex >= totalItems - currentCards}
                opacity={currentIndex >= totalItems - currentCards ? 0.4 : 1}
                cursor={currentIndex >= totalItems - currentCards ? "not-allowed" : "pointer"}
            >
                <Icon boxSize={6} color="black">
                    <CaretRightIcon />
                </Icon>
            </IconButton>
        </Box>
    );
};

export default BlogCardCarousel;
